'use client'

import { useStoreLocatorUrl } from '@/feature/store-locator'
import { Icon } from '@/ui/icons/icon/Icon'

import { Link } from '@/ui/links/link/Link.client'

type FooterFindUsProps = {
  name: string
}

export function FooterFindUsButton({ name }: FooterFindUsProps) {
  const storeLocatorUrl = useStoreLocatorUrl()

  if (!storeLocatorUrl) {
    return null
  }

  return (
    <Link
      href={storeLocatorUrl}
      opensInNewTab
      variant="button-primary"
      size="lg"
      iconLeft={<Icon.MapPin />}
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'footer',
        eventAction: 'clic cta',
        eventLabel:
          process.env.NEXT_PUBLIC_BRAND === 'dexis' ? 'trouver mon agence' : 'trouver mon magasin',
      }}
    >
      {name}
    </Link>
  )
}
